import { render } from "./FinnAreaStatistics.vue?vue&type=template&id=09c9479e&scoped=true"
import script from "./FinnAreaStatistics.vue?vue&type=script&lang=js"
export * from "./FinnAreaStatistics.vue?vue&type=script&lang=js"

import "./FinnAreaStatistics.vue?vue&type=style&index=0&id=09c9479e&scoped=true&lang=css"

import exportComponent from "/Users/lasse/Documents/DOFprojects/spontanpunkt-PWA/pwa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09c9479e"]])

export default __exports__